import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';
import classes from './Timeline.module.css';
import LogPostItem from 'components/Log/Timeline/LogPostItem/LogPostItem';
import LogPostItemSmall from 'components/Log/Timeline/LogPostItemSmall/LogPostItemSmall';
import Spinner from 'components/UI/Spinner/Spinner';
import { getMediaThumb } from 'shared/util';
import {
  formatPostItemDateRange,
  formatTimeRangeForPostsTableDisplay,
  getFullYearFromStringDate,
  getSeason,
  isSameSeason,
  isSameYear,
} from 'shared/utility';
import * as actions from 'store/actions';

class Timeline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPageNumber: 1,
    };
  }

  componentDidMount() {
    // Fetch posts for selected logs unless the user is returning from viewing post detail
    // In case when user is returning from post detail, we want to persist the posts that had been previously loaded are still loaded in state and
    // accessible on page for scroll

    if (this.props.filters.logIds.length > 0 && !this.props.prevPostId && this.props.postingAs.UserId) {
      this.props.handleLogFetch(1, null, true, false, false);
      window.scroll({ top: 0, left: 0 });
    } else if (this.props.prevPostId) {
      // prevPostId is used to determine location on log view to scroll to when user is returning from a post detail.
      // It needs to be cleared after use to avoid side effects
      this.props.handleClearPrevPostId();

      const prevPostElementTop = document.getElementById(`post-${this.props.prevPostId}`)
        ? document.getElementById(`post-${this.props.prevPostId}`).offsetTop - 200
        : 0;
      if (prevPostElementTop > 0 && this.props.currentLogs.Page.PageNum && Number.isInteger(this.props.currentLogs.Page.PageNum)) {
        window.scroll({ top: prevPostElementTop, left: 0 });
        // set currentPageNumber to the last page the user was on, if this isn't reset here, when the user scrolls down the page,
        // page 1 posts will be appended to the post list when a user scrolls down the page
        this.setState({ currentPageNumber: this.props.currentLogs.Page.PageNum });
      } else {
        this.props.handleLogFetch(1, null, true, false, false);
      }
    }
  }

  componentDidUpdate(prevProps) {
    // If user has toggled from one log to another
    // OR a user has edited/added/deleted a post
    // OR sort order or sort column has changed, fetch log
    // Or filters have been changed
    // fetch posts
    if (
      (this.props.submitted && !prevProps.submitted) ||
      (this.props.deleted && !prevProps.deleted) ||
      prevProps.sortColumns[this.props.selectedSortColumn].sortOrder !== this.props.sortColumns[this.props.selectedSortColumn].sortOrder ||
      prevProps.selectedSortColumn !== this.props.selectedSortColumn ||
      this.props.filters !== prevProps.filters ||
      (this.props.postingAs.UserId && !prevProps.postingAs.UserId)
    ) {
      // In case that selected logs and/or filters have been changed or a navlink being clicked, we need to reset the page number to 1,
      // tell the app to scroll up to top of page and fetch log from start
      this.props.onUpdateScrollToTopOfChild(true);
      this.setState({ currentPageNumber: 1 });
      this.props.handleLogFetch(1, null, true, false, false);
    }
    if (this.props.scrollToTopOfTimeline && !prevProps.scrollToTopOfTimeline) {
      window.scroll({ top: 0, left: 0 });
      this.props.onUpdateScrollToTopOfChild(false);
    }
  }

  fetchMorePosts = () => {
    if (this.props.currentLogs.PostCount > this.props.currentLogs.Posts.length && !this.props.loading) {
      const updatedPageNumber = this.state.currentPageNumber + 1;
      this.props.handleLogFetch(updatedPageNumber, null, true, false, false);
      this.setState({ currentPageNumber: updatedPageNumber });
    }
  };

  render = () => {
    let posts = null;

    if (this.props.currentLogs.Posts && this.props.currentLogs.Posts.length > 0) {
      posts = this.props.currentLogs.Posts.map((post, index) => {
        const displayDate =
          formatPostItemDateRange(post.Post.DateStartCalc, post.Post.DateEndCalc) +
          (post.Post.TimeStartCalc
            ? `, ${formatTimeRangeForPostsTableDisplay(post.Post.TimeStartCalc, post.Post.TimeEndCalc, post.Post.Ongoing)}`
            : '');
        let displayYear = null;
        let displaySeason = null;
        if (
          index > 1 &&
          isSameYear(post.Post.DateStartCalc, this.props.currentLogs.Posts[index - 1].Post.DateStartCalc) === false &&
          this.props.currentLogs.Posts.length !== index &&
          this.props.selectedSortColumn === 'DateStart'
        ) {
          displayYear = this.props.postViewSize === 'large' ? <h2>{getFullYearFromStringDate(post.Post.DateStartCalc)}</h2> : null;
          displaySeason = (
            <h3 className={classes.SeasonName}>
              {this.props.postViewSize === 'large'
                ? getSeason(post.Post.DateStartCalc)
                : `${getSeason(post.Post.DateStartCalc)} ${getFullYearFromStringDate(post.Post.DateStartCalc)}`}
            </h3>
          );
        } else if (
          index > 1 &&
          isSameSeason(post.Post.DateStartCalc, this.props.currentLogs.Posts[index - 1].Post.DateStartCalc) === false &&
          this.props.selectedSortColumn === 'DateStart'
        ) {
          displaySeason = (
            <h3 className={classes.SeasonName}>
              {this.props.postViewSize === 'large'
                ? getSeason(post.Post.DateStartCalc)
                : `${getSeason(post.Post.DateStartCalc)} ${getFullYearFromStringDate(post.Post.DateStartCalc)}`}
            </h3>
          );
        }
        return (
          <div id={`post-${post.Post.PostId}`} key={`${post.Post.PostId}-${index}`}>
            <div className={classes.YearAndSeason}>
              {displayYear}
              {!displayYear ? displaySeason : null}
            </div>
            {this.props.postViewSize === 'large' ? (
              <LogPostItem
                postImageUrl={
                  post.Files && post.Files.FileTop
                    ? post.Files.FileTop.MediaType === 'Video'
                      ? post.Files.FileTop.MediumImageURL
                      : post.Files.FileTop.FileURL
                    : null
                }
                handleSelect={this.props.handlePostSelect}
                categoryImage={post.Post.Type ? post.Post.Type : null}
                date={displayDate}
                page="timeline"
                post={post.Post}
                comments={post.Comments}
                isUnread={post.MyHistory && Object.keys(post.MyHistory).length === 0}
                logId={this.props.currentLogs.Id}
                sortBy={this.props.selectedSortColumn}
              />
            ) : (
              <LogPostItemSmall
                postImageUrl={post.Files && post.Files.FileTop ? getMediaThumb(post.Files.FileTop) : null}
                handleSelect={this.props.handlePostSelect}
                categoryImage={post.Post.Type ? post.Post.Type : null}
                date={displayDate}
                page="timeline"
                color={post.Post.Color}
                comments={post.Comments}
                post={post.Post}
                isUnread={post.MyHistory && Object.keys(post.MyHistory).length === 0}
                logId={this.props.currentLogs.Id}
                sortBy={this.props.selectedSortColumn}
              />
            )}
          </div>
        );
      });
    }

    let initialYearAndSeason = null;
    if (this.props.currentLogs.Posts && this.props.currentLogs.Posts.length > 0 && this.props.selectedSortColumn === 'DateStart') {
      initialYearAndSeason = (
        <div className={[classes.YearAndSeason, classes.Top].join(' ')}>
          <h2>{getFullYearFromStringDate(this.props.currentLogs.Posts[0].Post.DateStartCalc)}</h2>
          <h3 className={classes.SeasonName}>{getSeason(this.props.currentLogs.Posts[0].Post.DateStartCalc)}</h3>
        </div>
      );
    }
    let timeline = null;
    if (this.props.currentLogs.LogIds === null) {
      timeline = <Spinner lightColor />;
    } else if (this.props.currentLogs.Posts.length > 0) {
      timeline = (
        <div className={this.props.postViewSize === 'small' ? classes.SmallView : classes.LargeView}>
          {initialYearAndSeason}
          <InfiniteScroll
            element="div"
            dataLength={this.props.currentLogs.Posts.length}
            next={this.fetchMorePosts}
            endMessage=""
            scrollThreshold="500px"
            hasMore={
              this.props.loading && this.props.currentPageNumber === 1 ? true : this.props.currentLogs.Posts.length < this.props.currentLogs.PostCount
            }
          >
            {posts}
          </InfiniteScroll>
        </div>
      );
    } else {
      timeline = <h3 className={classes.NoPostsAvailable}>This log doesn't yet have any posts</h3>;
    }
    return (
      <div className={classes.LogContainer} id="log-container">
        {timeline}
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    logs: state.user.postingAs.Logs,
    submitted: state.post.submitted,
    currentLogs: state.logs.currentLogs,
    loading: state.logs.loading === true,
    scrollToTopOfTimeline: state.app.scrollToTopOfChild,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateScrollToTopOfChild: (scrollToTop) => dispatch(actions.updateScrollToTopOfChild(scrollToTop)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Timeline);
